import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { styled as styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  width: '100%',
  maxWidth: '400px',
  height: '36px !important',
  backgroundColor: theme.palette.background.paper,
  '& .MuiInputBase-root': {
    height: '36px',
  },
  '& .MuiInputBase-input': {
    height: '36px',
    padding: '0 14px 0 0',
    boxSizing: 'border-box',
  },
  '& .MuiInputAdornment-root': {
    height: '100%',
    maxHeight: 'none',
    marginTop: '0px !important',
    '& .MuiSvgIcon-root': {
      marginTop: '0px',
    },
  },
}));
